import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "left-block-wrapper d-flex flex-column justify-content-center" }
const _hoisted_2 = { class: "logo d-flex justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "logo-headline" }, "Scrapx", -1)
const _hoisted_4 = {
  key: 0,
  class: "auth-wrapper container"
}
const _hoisted_5 = { class: "title-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Would you like to turn off the monitoring for the following website?", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "text-dark italic" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 1,
  class: "auth-wrapper container"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "title-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "You will not receive any further notifications.")
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo_icon = _resolveComponent("logo-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_logo_icon)
    ]),
    _hoisted_3,
    (!_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-danger bg-danger mt-4",
              disabled: _ctx.isSubmitting,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, _toDisplayString(_ctx.isSubmitting ?
      'Deactivating...' : 'Deactivate'), 9, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSubmitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true)
  ]))
}